var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mypooq-inner-wrap"},[_c('using-break-down-list',{attrs:{"viewMode":"singular"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }